import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { productImage } from "@/components/ProductCard";
import { useMedia } from "@/context/MediaContext";
import { useProducts } from "@/context/ProductsContext";

export default function CollectionsGrid() {
  const img = useMedia();
  const { products } = useProducts();
  return (
    <section data-testid="collections-grid-section" className="border-t border-black/10">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-20 md:py-28">
        <Reveal className="max-w-2xl mb-14">
          <p className="overline-label">Collections</p>
          <h2 className="font-serif-brand text-4xl md:text-5xl font-light mt-4">A fragrance wardrobe.</h2>
          <p className="mt-4 text-sm md:text-base text-black/55 leading-relaxed">
            Five compositions designed around the many facets of masculinity and femininity — so you can express a different part of yourself every day.
          </p>
          <Link to="/collections" data-testid="collections-grid-view-all" className="mt-6 inline-block link-line text-[0.68rem] uppercase tracking-[0.22em] font-medium">
            Discover all collections
          </Link>
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-x-6 gap-y-12">
          {products.map((p, i) => (
            <Reveal key={p.slug} delay={(i % 5) * 0.08}>
              <Link to={`/products/${p.slug}`} data-testid={`collection-grid-card-${p.slug}`} className="group block">
                <div className="aspect-[3/4] overflow-hidden bg-[#EFE9E1]">
                  <img src={p.aestheticImage || productImage(p, img)} alt={p.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105" />
                </div>
                <h3 className="mt-5 font-serif-brand text-2xl font-light group-hover:text-[#BA8D53] transition-colors duration-300">{p.name}</h3>
                <p className="mt-2 text-sm text-black/55 leading-relaxed line-clamp-3">{p.description}</p>
                <span className="mt-3 inline-block link-line text-[0.65rem] uppercase tracking-[0.22em] font-medium">Discover</span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
